import { PathParamLossError } from '@xt/client/experimental/request/utils'

export const useTemplateString = function (str: string, data: any) {
  const interpolate = /{(\w+?)}/g
  str.match(interpolate)?.map(v => {
    v = v.substring(1, v.length - 1)

    // data[v] 为 undefined | null 时，抛出异常
    if (data[v] == null) {
      throw new PathParamLossError(`缺少path参数(${v}: ${data[v]})，url: ${str}`)
    }

    str = str.replace(`{${v}}`, data[v].toString())
  })
  return str
}
